import { Components } from '@mui/material/styles';

const muiTabsStyles: Components = {
  MuiTabs: {
    styleOverrides: {
      root: { maxHeight: '62px' },
      indicator: {
        height: '4px',
        zIndex: 2,
        '@media (max-width: 1715px)': {
          height: '3px'
        }
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: '16px',
        color: 'var(--blue-4)',
        padding: '0 40px',
        // minHeight: '48px',
        // height: '48px',
        flexDirection: 'row',
        fontWeight: '600',
        gap: '8px',
        alignItems: 'center',
        '&.MuiTab-labelIcon': {
          minHeight: 50
        },
        '&.Mui-selected': {
          fontWeight: '600'
        },
        '& .MuiTab-iconWrapper': {
          marginBottom: 0
        },
        '@media (max-width: 1715px)': {
          fontSize: '13px',
          padding: '0 34px'
        }
      }
    }
  }
};

export default muiTabsStyles;
